module.exports = __webpack_public_path__ + "images/emoji/penguin.46e5e5611569c16994c9.png";